import { useEffect, useState } from "react";
import {
  readVisualViewport,
  sameVisualViewport,
  type VisualViewportBox,
} from "@/lib/visualViewport";

// Returns the current visual viewport box (height, offset from the top of the
// layout viewport, zoom), accounting for the on-screen keyboard on iOS
// (window.innerHeight does not shrink when the keyboard opens on iOS Safari,
// and Safari pans the visual viewport to reveal the focused field).
export function useVisualViewport(): VisualViewportBox {
  const [box, setBox] = useState<VisualViewportBox>(readVisualViewport);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const vv = window.visualViewport;

    const update = () => {
      const next = readVisualViewport();
      setBox((previous) => (sameVisualViewport(previous, next) ? previous : next));
    };

    update();

    if (vv) {
      vv.addEventListener("resize", update);
      vv.addEventListener("scroll", update);
    }
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);

    return () => {
      if (vv) {
        vv.removeEventListener("resize", update);
        vv.removeEventListener("scroll", update);
      }
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return box;
}
